import moment from 'moment';

export function convertISOToLocalDate(isoString, format = "LLL") {
  const date = moment(isoString);
  const localizedDate = date.format(format); // Change the format as per your requirement
  return localizedDate;
}
